export var AccountSection;
(function (AccountSection) {
    AccountSection["Assets"] = "assets";
    AccountSection["Payables"] = "payables";
    AccountSection["PartnersCapital"] = "partnersCapital";
    AccountSection["Income"] = "income";
    AccountSection["Expenses"] = "expenses";
})(AccountSection || (AccountSection = {}));
export var PayableReceivableCategory;
(function (PayableReceivableCategory) {
    PayableReceivableCategory["PayableOperations"] = "payableOperations";
    PayableReceivableCategory["PayableInvestment"] = "payableInvestment";
    PayableReceivableCategory["PayableCapital"] = "payableCapital";
    PayableReceivableCategory["ReceivableOperations"] = "receivableOperations";
    PayableReceivableCategory["ReceivableInvestment"] = "receivableInvestment";
    PayableReceivableCategory["ReceivableCapital"] = "receivableCapital";
    PayableReceivableCategory["ReceivableBankTransfer"] = "receivableBankTransfer";
    PayableReceivableCategory["DeferredIncome"] = "deferredIncome";
    PayableReceivableCategory["PrepaidExpenses"] = "prepaidExpenses";
})(PayableReceivableCategory || (PayableReceivableCategory = {}));
const payableCategories = [
    PayableReceivableCategory.PayableOperations,
    PayableReceivableCategory.PayableInvestment,
    PayableReceivableCategory.PayableCapital,
];
const receivableCategories = [
    PayableReceivableCategory.ReceivableOperations,
    PayableReceivableCategory.ReceivableInvestment,
    PayableReceivableCategory.ReceivableCapital,
    PayableReceivableCategory.ReceivableBankTransfer,
];
export const reconcilableCategories = [
    ...payableCategories,
    ...receivableCategories,
];
export function isPayableCategory(category) {
    return !!category && payableCategories.includes(category);
}
export function isReceivableCategory(category) {
    return !!category && receivableCategories.includes(category);
}
export var BalanceSheetSection;
(function (BalanceSheetSection) {
    // Assets
    BalanceSheetSection["CashAndCashEquivalents"] = "cashAndCashEquivalents";
    BalanceSheetSection["InvestmentsAtCost"] = "investmentsAtCost";
    BalanceSheetSection["UnrealisedGainLoss"] = "unrealisedGainLoss";
    BalanceSheetSection["UnrealisedFXGainLoss"] = "unrealisedFXGainLoss";
    BalanceSheetSection["ReceivablesAndPrepayments"] = "receivablesAndPrepayments";
    BalanceSheetSection["AccruedIncome"] = "accruedIncome";
    BalanceSheetSection["CapitalDueFromPartners"] = "capitalDueFromPartners";
    // Liabilities (Payables section in GL)
    BalanceSheetSection["AccountsPayable"] = "accountsPayable";
    BalanceSheetSection["AccruedExpenses"] = "accruedExpenses";
    BalanceSheetSection["CapitalDueToPartners"] = "capitalDueToPartners";
})(BalanceSheetSection || (BalanceSheetSection = {}));
//# sourceMappingURL=schema.js.map